<template>
  <div class="notifications__container" v-click-outside="vcoConfig">
    <div class="notifications__icon-container">
      <notification-logo @click="listIsOpen = !listIsOpen" />
      <div class="notifications__unread-indicator" v-if="unreadCount" />
    </div>
    <notifications-list v-if="listIsOpen" @on-close="onClose" @decrement-unread="decrementUnread"
                        @get-unread-count="getUnreadCount" />
  </div>
</template>

<script>
import { useToast } from 'vue-toastification'
import { clickableNotificationTypes, notificationTypes } from "../../constants/notificationTypes";

import UserService from "../../services/userService";
import NotificationsService from "../../services/notificationsService";
import NotificationsList from "./NotificationsList";

import { getTokenInit, messaging } from "../../../firebase";
import NotificationLogo from "../icons/NotificationLogo";
import NotificationItem from "./NotificationItem";
import { onMessage } from "firebase/messaging";

export default {
  components: {
    NotificationLogo,
    NotificationsList,
  },
  data() {
    return {
      unreadCount: 0,
      listIsOpen: false,
      vcoConfig: {
        capture: true,
        handler: () => {
          this.onClose()
        },
      },
    }
  },
  methods: {
    async onGetToken() {
      try {
        const currentToken = await getTokenInit()
        if (currentToken) {
          try {
            await UserService.setCurrentUserDeviceId(currentToken)

            sessionStorage.setItem('registration_id', currentToken)
          } catch (e) {
            console.error(e)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getUnreadCount() {
      try {
        const { data } = await NotificationsService.getUnredNotificationsCount()

        this.unreadCount = data.count
      } catch (e) {
        console.error(e)
      }
    },
    onClose() {
      this.listIsOpen = false
    },
    decrementUnread() {
      this.unreadCount -= 1
    },
  },
  mounted() {
    onMessage(messaging, (message) => {
      const { data: { event_type: type, notification, ...rest }, notification: { body } } = message

      if (this.$route.name === 'chats' && type === notificationTypes.NEW_MESSAGE_RECEIVED) {
        NotificationsService.markNotificationsAsRead([notification])
        return
      }

      this.toast({
        component: NotificationItem,
        props: {
          notification: {
            uuid: notification,
            type,
            message: body,
            read: true,
            clickable: clickableNotificationTypes.includes(type),
            ...rest,
          },
          individual: true,
          router: this.$router,
        },
      })
    })

    this.onGetToken()
    this.getUnreadCount()
  },
  created() {
    this.toast = useToast()
  },
}
</script>

<style lang="scss" scoped>
.notifications {
  &__container {
    margin: 0 24px 0 40px;
    position: relative;
  }

  &__icon-container {
    position: relative;
    cursor: pointer;
  }

  &__unread-indicator {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background-color: $red-alert;
    top: 0;
    right: 0;
  }
}

</style>
